import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { QRCodeModule } from 'angularx-qrcode';

import { BoletoViewComponent } from './boleto-view.component';
import { PixPaymentDisplayComponent } from './pix-payment-display.component';
import { PixPaymentPanelComponent } from './pix-payment-panel.component';

@NgModule({
  declarations: [
    PixPaymentPanelComponent,
    PixPaymentDisplayComponent,
    BoletoViewComponent,
  ],
  imports: [CommonModule, MatButtonModule, QRCodeModule],
  exports: [
    PixPaymentPanelComponent,
    PixPaymentDisplayComponent,
    BoletoViewComponent,
  ],
})
export class PixPaymentPanelModule {}
